import React, { HTMLAttributes, HTMLProps } from 'react';
import { useSelector } from 'react-redux';

import { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import useClasses from '../../hooks/useClasses';

import avatarImage1 from '../../assets/images/avatars/avatar-1.svg';
import avatarImage2 from '../../assets/images/avatars/avatar-2.svg';
import avatarImage3 from '../../assets/images/avatars/avatar-3.svg';
import avatarImage4 from '../../assets/images/avatars/avatar-4.svg';
import avatarImage5 from '../../assets/images/avatars/avatar-5.svg';
import avatarImage6 from '../../assets/images/avatars/avatar-6.svg';
import avatarImage7 from '../../assets/images/avatars/avatar-7.svg';
import avatarImage8 from '../../assets/images/avatars/avatar-8.svg';
import avatarImage9 from '../../assets/images/avatars/avatar-9.svg';
import avatarImage10 from '../../assets/images/avatars/avatar-10.svg';
import avatarImage11 from '../../assets/images/avatars/avatar-11.svg';
import avatarImage12 from '../../assets/images/avatars/avatar-12.svg';

import './style.scss';

interface Props extends HTMLProps<HTMLAttributes<HTMLDivElement>> {
  avatar: number;
}

const Avatar: React.FC<Props> = ({ avatar, className }) => {
  const { buildClass, joinClasses } = useClasses('Avatar');

  const username = useSelector<ImmutableRootState<string>, string>((state) => {
    const uid = state.getIn(['login', 'uid']);
    return state.getIn(['user', uid, 'field_name', 0, 'value'], '');
  });

  const avatarImages = {
    'avatar-1': avatarImage1,
    'avatar-2': avatarImage2,
    'avatar-3': avatarImage3,
    'avatar-4': avatarImage4,
    'avatar-5': avatarImage5,
    'avatar-6': avatarImage6,
    'avatar-7': avatarImage7,
    'avatar-8': avatarImage8,
    'avatar-9': avatarImage9,
    'avatar-10': avatarImage10,
    'avatar-11': avatarImage11,
    'avatar-12': avatarImage12,
  };

  return (
    <div className={joinClasses(buildClass(), className)}>
      <img src={String(avatarImages[`avatar-${avatar || 1}`])} alt={username} />
    </div>
  );
};

export default Avatar;
